"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./SpotlightArea.module.css";

export function SpotlightArea({
  as: _Component = _Builtin.Section,
  bodyText = "",
}) {
  return (
    <_Component
      className={_utils.cx(_styles, "section-17")}
      tag="div"
      grid={{
        type: "section",
      }}
    >
      <_Builtin.Block className={_utils.cx(_styles, "container-41")} tag="div">
        <_Builtin.Block
          className={_utils.cx(
            _styles,
            "content-width-extra-large",
            "align-center"
          )}
          tag="div"
        >
          <_Builtin.RichText
            className={_utils.cx(_styles, "article")}
            tag="div"
            slot=""
          >
            {bodyText}
          </_Builtin.RichText>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "combine-section_cta3")}
        tag="section"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "combine-padding-global-6")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "combine-padding-section-large-2")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "combine-container-large-5")}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "combine-cta3_component")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "combine-container-small-4")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "combine-text-align-center-4"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "div-block-112")}
                      tag="div"
                    >
                      <_Builtin.Heading
                        className={_utils.cx(_styles, "combine-cta3_title")}
                        tag="h2"
                      >
                        {"Ready to get Started?"}
                      </_Builtin.Heading>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "combine-text-color-white"
                        )}
                        tag="div"
                      >
                        {"Sign up to EngineEars today!"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(_styles, "combine-button-wrapper-4")}
                      tag="div"
                    >
                      <_Builtin.Link
                        className={_utils.cx(
                          _styles,
                          "engineears-button-black"
                        )}
                        button={true}
                        block=""
                        options={{
                          href: "https://engineears.com/signup?flow=6&step=3",
                        }}
                      >
                        {"Sign Up for Free"}
                      </_Builtin.Link>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
